import { FC } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DetailsRow } from 'lib/ClientDataDetails/DetailsRow';
import TemplateDetails from '../TemplateDetails';
import { generalEnum } from 'screens/Clients/utils/generalEnum';
import { ClientDetailsDeedTypeEnum } from 'types/ClientDetails/Enums/ClientDetailsDeedTypeEnum';
import { ClientDetailsDeed } from 'types/ClientDetails/ClientDetailsDeed';
import { ClientDetailsRegistrationStatusEnum } from 'types/ClientDetails/Enums/ClientDetailsRegistrationStatusEnum';

type DeedsDetailsProps = {
  deeds: ClientDetailsDeed[];
};

const DeedsDetails: FC<DeedsDetailsProps> = ({ deeds }) => {
  const { t } = useTranslation();
  const tl = 'clients.clientData.deedsDetails';

  return (
    <Grid container data-testid="DeedsDetails-container">
      {deeds.map((deed) => (
        <Grid xs={12} md={6} px={3} py={2}>
          <TemplateDetails title={t(`${tl}.deedTitle`)}>
            <DetailsRow label={t(`${tl}.deedNumber`)} value={deed?.number} />
            <DetailsRow
              label={t(`${tl}.deedType`)}
              value={generalEnum('deedType', deed?.type, ClientDetailsDeedTypeEnum)}
            />
          </TemplateDetails>
          {deed.registrations?.map((registration) => (
            <TemplateDetails title={t(`${tl}.registryTitle`)}>
              <DetailsRow
                type="currency"
                label={t(`${tl}.registryAmount`)}
                value={registration?.amount}
              />
              <DetailsRow
                label={t(`${tl}.registryState`)}
                value={generalEnum(
                  'realEstateRegistrationStatus',
                  registration?.status,
                  ClientDetailsRegistrationStatusEnum
                )}
              />
              <DetailsRow
                type="boolean"
                label={t(`${tl}.registryOpen`)}
                value={registration?.openEnd}
              />
            </TemplateDetails>
          ))}
        </Grid>
      ))}
    </Grid>
  );
};

export default DeedsDetails;
